import { useState } from 'react'
import { useQuery } from '@truepill/tpos-react-router'
import type { Pod } from '@truepill/tpos-types'
import MultiSelect, { type MultiSelectOption } from 'components/MultiSelect'
import { GET_ALL_PODS } from 'gql'
import { usePlusClient } from 'providers/VisionRouter'

type PodSelectProps = {
  value?: string
  disabled?: boolean
  onSelect: (podNames: string[]) => void
}

const PodSelect = (props: PodSelectProps): JSX.Element => {
  const { onSelect, value, disabled } = props
  const [allOptionsChecked, setAllOptionsChecked] = useState(false)
  const { currentLocation } = usePlusClient()

  const locationIds = currentLocation?.queryMap?.locationIds?.length ? currentLocation.queryMap.locationIds : []

  const { data, loading, error } = useQuery(GET_ALL_PODS, {
    variables: { locationIds },
  })

  if (loading || error) {
    return <></>
  }

  const pods: Pod[] = data?.getAllPods
  // won't show pod filter unless there are pods to filter by
  if (!pods.length) {
    return <></>
  }

  const multiSelectOptions: MultiSelectOption<string>[] = [
    { label: 'Select All', value: 'All', selectAll: true },
    ...pods.map((p: Pod) => ({ label: p.podName, value: p.podName })),
  ]
  const multiSelectValues =
    value?.includes('All') || allOptionsChecked
      ? multiSelectOptions.map(opt => opt.value)
      : Array.isArray(value)
      ? value
      : value?.split(', ') || []

  return (
    <MultiSelect
      label="Pod"
      disabled={locationIds?.length > 1 || disabled}
      value={multiSelectValues}
      placeholder="Select pods…"
      options={multiSelectOptions}
      onChange={values => {
        if (values.includes('All')) {
          onSelect(['All'])
          setAllOptionsChecked(true)
        } else {
          onSelect(values)
          setAllOptionsChecked(false)
        }
      }}
    />
  )
}

export default PodSelect
